import { useMemo, useState } from 'react';

const useSelection = () => {
  const [allSelected, setAllSelected] = useState(false);
  const [selected, setSelected] = useState({});
  const [items, setItems] = useState([]);

  const updateItems = (newItems) => {
    if (newItems) {
      setItems(newItems);
      setSelected(
        newItems.reduce(
          (selected, { id }) => ({
            ...selected,
            [id]: allSelected,
          }),
          {}
        )
      );
    }
  };

  const toggleAllSelected = (e) => {
    const { checked } = e.target;
    setAllSelected(checked);

    setSelected(
      items.reduce(
        (selected, { id }) => ({
          ...selected,
          [id]: checked,
        }),
        {}
      )
    );
  };

  const toggleSelected = (id) => (e) => {
    const { checked } = e.target;

    setSelected((prevSelected) => {
      const newSelected = {
        ...prevSelected,
        [id]: checked,
      };

      // Check if all items are now selected
      const allChecked = items.every(item => newSelected[item.id]);
      setAllSelected(allChecked);

      return newSelected;
    });
  };

  const selected_ids = useMemo(()=> Object.keys(selected)
  .filter(id => selected[id]) // Filter by true
  .join(',')
, [selected])

  return {
    allSelected,
    selected,
    toggleAllSelected,
    toggleSelected,
    updateItems,
    selected_ids
  };
};

export default useSelection;
